import { render, staticRenderFns } from "./file-tab.vue?vue&type=template&id=56e4d39d"
import script from "./file-tab.vue?vue&type=script&lang=js"
export * from "./file-tab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports